import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-selftour-verify-base',
  templateUrl: './selftour-verify-base.component.html',
  styleUrls: ['./selftour-verify-base.component.css']
})
export class SelftourVerifyBaseComponent implements OnInit {
  address: string = null;
  constructor() {
    let address = localStorage.getItem('PropertyAddress');

    if (address !== null && address !== undefined)
    {
      this.address = address;
    }
   }

  ngOnInit() {
  }

}
